import React from "react";
import { connect } from "react-redux";

function PublisherButton({ permissionsUser }) {
  if (!permissionsUser) {
    return <></>;
  }

  if (!permissionsUser.includes("add-site-publisher-via-user")) {
    return <></>;
  }

  return (
    <div className="d-none pr-3 d-lg-flex">
      <a
        target="_blank"
        href={`${process.env.REACT_APP_DOMAIN_PUBLISHER}`}
        className="btn btn-success"
      >
        پنل نمایش دهنده
      </a>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    permissionsUser: state.main.permissionsUser,
  };
};
export default connect(mapStateToProps, null)(PublisherButton);
